import { MeiliSearchResponse } from "@interfaces";
import { executeMeiliSearchOperation } from "./getMeiliSearchClient";

const MAX_CACHE_SIZE = 100;

export const createCachedSearchService = (
  indexName: string,
  serviceName: string
) => {
  const cache = new Map<string, MeiliSearchResponse>();

  const addToCache = (key: string, value: MeiliSearchResponse) => {
    if (cache.size >= MAX_CACHE_SIZE) {
      const firstKey = cache.keys().next().value;
      if (firstKey) cache.delete(firstKey);
    }
    cache.set(key, value);
  };

  return async (input: string): Promise<MeiliSearchResponse> => {
    if (cache.has(input)) return cache.get(input)!;

    try {
      const responseData =
        await executeMeiliSearchOperation<MeiliSearchResponse>(
          async (client) => {
            const result = await client.index(indexName).search<any>(input);
            return result;
          }
        );

      addToCache(input, responseData);
      return responseData;
    } catch (error) {
      console.error(`Error getting ${serviceName} from MeiliSearch`, error);
      throw error;
    }
  };
};
